module.exports = __webpack_public_path__ + "img/car.92bb1990.png";